// extracted by mini-css-extract-plugin
module.exports = {"products-slider":"ProductsSlider_products-slider__clNvR","products-slider-link":"ProductsSlider_products-slider-link__kgT2j","load":"ProductsSlider_load__OThP_"};